export default Object.freeze(
  {
    ADMIN: 1,
    MERCHANT: 2,
    MASTER_MERCHANT: 3,
  }
)